import React, {useEffect, useState} from "react";

import VehicleTagIndex from "../../../components/support/VehicleTag/index"

function Index(props) {

    return <VehicleTagIndex isTenant={true}/>
}

export default Index